/* eslint-disable no-shadow */
import React, { FunctionComponent } from "react";
import ReactTooltip from "react-tooltip";
import {
  PricingWrapper,
  PricingTitle,
  PricingOptions,
  PricingOption,
  Price,
  PriceDescription,
  CallInstructions,
  CallText,
  CallButtonLink,
} from "./styles/pricing-styles";

const Pricing: FunctionComponent<unknown> = () => (
  <PricingWrapper className="animated fadeIn delay-3">
    <PricingTitle
      data-test-id="pay-as-you-go-title"
      className="animated fadeIn delay-6"
    >
      Premium Pricing
    </PricingTitle>
    <PricingOptions
      data-test-id="pay-as-you-go-options"
      className="animated fadeIn delay-6"
    >
      <PricingOption>
        <Price>£159</Price>
        <PriceDescription>1x job credit</PriceDescription>
      </PricingOption>
      <PricingOption>
        <Price>£429</Price>
        <PriceDescription>3x job credits - 15% saving</PriceDescription>
      </PricingOption>
      <PricingOption>
        <Price>£679</Price>
        <PriceDescription>5x job credits - 20% saving</PriceDescription>
      </PricingOption>
      <PricingOption>
        <Price>£1,250</Price>
        <PriceDescription>10x job credits - 20% saving</PriceDescription>
      </PricingOption>
      <PricingOption noBorder>
        <Price>£1,785</Price>
        <PriceDescription>15x job credits - 25% saving</PriceDescription>
      </PricingOption>
    </PricingOptions>
    <CallInstructions className="animated fadeIn delay-7">
      <CallText>
        To upgrade to Premium call:{" "}
        <CallButtonLink
          href="tel:01613007235"
          title="Call"
          data-tip="Click to make a call from this device"
          data-for="premium-call-action"
        >
          0161 300 7235.
        </CallButtonLink>
      </CallText>
      <ReactTooltip
        place="bottom"
        type="dark"
        effect="solid"
        aria-haspopup="true"
        id="premium-call-action"
      />
    </CallInstructions>
  </PricingWrapper>
);

export default Pricing;
